import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { FormlySelectModule } from '@ngx-formly/core/select';

import { AvatarModule, SelectBoxModule } from '@lockton-apps/shared/ui/lui';

import { SelectBoxTypeComponent } from './select-box-type.component';
import { MaterialModule } from '@lockton-apps/material';

@NgModule({
  declarations: [SelectBoxTypeComponent],
  imports: [
    CommonModule,
    SelectBoxModule,
    ReactiveFormsModule,
    FormlySelectModule,
    MaterialModule,
    AvatarModule,
    FormlyModule.forChild({
      types: [
        {
          name: 'select-box',
          component: SelectBoxTypeComponent,
          wrappers: ['form-field', 'addons'],
          defaultOptions: {
            props: {
              columns: 3,
            },
          },
        },
      ],
    }),
  ],
})
export class SelectBoxTypeModule {}
